import { Loader2 } from "lucide-react";
import React from "react";

const LoadingSpinner = ({ message }) => (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-gray-50 to-gray-100 dark:from-slate-950 dark:to-slate-900">
        <div className="flex flex-col items-center">
            <div className="inline-flex h-14 w-14 items-center justify-center rounded-full border-2 border-red-100 dark:border-red-500/40 bg-white dark:bg-slate-900 shadow-sm dark:shadow-red-900/40">
                <Loader2 className="animate-spin text-red-600" size={32} />
            </div>
            <p className="mt-4 text-sm font-medium text-gray-700 dark:text-slate-100">
                {message}
            </p>
            <p className="mt-1 text-xs text-gray-400 dark:text-slate-500">
                Fetching the latest from Canadian publishers…
            </p>
        </div>
    </div>
);

export default LoadingSpinner;
